import { useNavigate, useParams } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../constents';

function SideMenue({ patientId, allData }) {
  const { page } = useParams();
  const navigate = useNavigate();

  const handlePatientTab = (tab) => {
    if (tab === 'dashboard') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}`);
    } else if (tab === 'profile') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/profile/${patientId}`);
    } else if (tab === 'insurance') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/insurance/${patientId}`);
    } else if (tab === 'docs') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/docs/${patientId}`);
    } else if (tab === 'appointments') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/patappointment/${patientId}`);
    } else if (tab === 'screening') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/screening/${patientId}`);
    }
  };
  return (
    <div className="dash-side-nav">
      <span className="ch-pt-pic">
        <img
          className="nav-pt-pc img-hover"
          src={allData?.photograph ? allData?.photograph : './images/user.jpg'}
          alt=""
        />
      </span>
      <nav className="chart-left-nav">
        <div
          className={
            page === 'counNote' || page === 'treatPlan'
              ? 'left-nav-lbl lft-nav-active-t'
              : 'left-nav-lbl'
          }
          onClick={() => handlePatientTab('dashboard')}
        >
          <span className="left-nav-logo">D</span>
          <span className="fontsize8">Dashboard</span>
        </div>
        <div
          className={
            page === 'profile'
              ? 'left-nav-lbl lft-nav-active-t'
              : 'left-nav-lbl'
          }
          onClick={() => handlePatientTab('profile')}
        >
          <span className="left-nav-logo">P</span>
          <span className="fontsize8">Pt. Profile</span>
        </div>
        <div
          className={
            page === 'insurance' || page === 'priorauth'
              ? 'left-nav-lbl lft-nav-active-t'
              : 'left-nav-lbl'
          }
          onClick={() => handlePatientTab('insurance')}
        >
          <span className="left-nav-logo">I</span>
          <span className="fontsize8">Insurance</span>
        </div>
        <div className="left-nav-lbl hide">
          <span className="left-nav-logo">M</span>
          <span className="fontsize8">Msg. & Mail</span>
        </div>
        <div
          className={
            page === 'docs' ? 'left-nav-lbl lft-nav-active-t' : 'left-nav-lbl'
          }
          onClick={() => handlePatientTab('docs')}
        >
          <span className="left-nav-logo">D</span>
          <span className="fontsize8">Documents</span>
        </div>
        <div
          className={
            page === 'patappointment' //doubt
              ? 'left-nav-lbl lft-nav-active-t'
              : 'left-nav-lbl'
          }
          onClick={() => handlePatientTab('appointments')}
        >
          <span className="left-nav-logo">A</span>
          <span className="fontsize8">Appointments</span>
        </div>
        {/* <div
          className={
            page === 'screening'
              ? 'left-nav-lbl lft-nav-active-t'
              : 'left-nav-lbl'
          }
          onClick={() => handlePatientTab('screening')}
        >
          <span className="left-nav-logo">S</span>
          <span className="fontsize8">Screening</span>
        </div> */}
      </nav>
    </div>
  );
}

export default SideMenue;
